import { render } from "./MyAccount.vue?vue&type=template&id=448925b9&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"

import "./MyAccount.vue?vue&type=style&index=0&id=448925b9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-448925b9"

export default script